import React, { useState } from "react";
import PropTypes from "prop-types";
import { uploadFile } from "react-s3";

import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

import styles from "../App.module.css";
import { getAwsKeys } from "../lib/api";

// Request endpoint in api, returns region, access key, and secret then decodes jwt

const S3Upload = ({ updateFn_c, updateFn_s }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileName, setSelectedFileName] = useState(null);
  const [nonPdf, setNonPdf] = useState(false);

  const handleFileInput = (e) => {
    const fileExt = e.target.files[0].name
      .substr(e.target.files[0].name.length - 4)
      .toLowerCase();
    if (fileExt !== ".pdf") {
      setNonPdf( true );
      return;
    }
    const fileName = e.target.files[0].name.substr(
      0,
      e.target.files[0].name.length - 4
    );
    const nameNum = Math.floor(Math.random() * 1000000);
    const newName = fileName + nameNum + fileExt;
    const newFile = new File([e.target.files[0]], newName);
    setSelectedFileName(e.target.files[0].name);
    setSelectedFile(newFile);
    setNonPdf( false );
  };

  const uploadHandler = async (file) => {
    const postParams = {
      apiKey: process.env.REACT_APP_ADMIN_API_KEY,
    };
    const config = await getAwsKeys(postParams);
    await handleUpload(file, config);
  };

  const handleUpload = async (file, config) => {
    uploadFile(file, config)
      .then((data) => updateFn_s(data.location))
      .then(() => updateFn_c(selectedFileName))
      .catch((err) => console.error(err));
  };

  return (
    <div>
      <Form.Group className={styles["flex-wrapper"]}>
        {nonPdf && <label for='fileinput' className={styles['error-text']}>Please upload a PDF file.</label>} 
        <Form.Control
          type="file"
          className={styles["half-screen"]}
          onChange={handleFileInput}
        />
        <Button
          className={[styles["btn-round"]]}
          onClick={() => uploadHandler(selectedFile)}
          disabled={nonPdf}
        >
          {" "}
          Upload
        </Button>
      </Form.Group>
    </div>
  );
};

S3Upload.propTypes = {
  updateFn_c: PropTypes.func,
  updateFn_s: PropTypes.func,
};

export default S3Upload;
